// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import ValuationComp from '../../components/Company/CompanyValuation/ValuationPage';
// Type imports:
import { ICompanyViewModel } from '../../types/CompanyTypes';

const Valuation: React.FC<ICompanyViewModel> = ({
    id,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <ValuationComp
                id={id}
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
            />
        </Entrypoint>
    );
}

export default Valuation;